import ACTIONS from '../constants/actions';
import {cloneObject} from '../tools/helpers';

const DEFAULT_PAGINATOR = {
  page: 1,
  per_page: 6
};

export const initialState = {
  site_collection: [],
  partners_collection: [],
  stats: null,
  average: null,
  paginator: {
    ...DEFAULT_PAGINATOR
  },
  newReview: null
};


const reviewsReducer = function(state = initialState, action) {
  const actionHandlers = {
    [ACTIONS.FETCH_REVIEWS_SUCCESS]() {
      return {
        ...state,
        site_collection: action.payload.reviews,
        paginator: action.payload.paginator
      };
    },
    [ACTIONS.FETCH_REVIEWS_STATS_SUCCESS]() {
      return {
        ...state,
        stats: action.payload.stats,
        average: action.payload.average
      };
    },
    [ACTIONS.FETCH_PARTNERS_REVIEWS_SUCCESS]() {
      return {
        ...state,
        partners_collection: action.payload.reviews
      };
    },
    [ACTIONS.RESET_PARTNERS_REVIEWS]() {
      return {
        ...state,
        partners_collection: []
      };
    },
    [ACTIONS.RESET_REVIEWS]() {
      return {
        ...state,
        site_collection: [],
        stats: null,
        average: null,
        paginator: {
          ...DEFAULT_PAGINATOR
        }
      };
    },
    [ACTIONS.RESET_REVIEWS_STATS]() {
      return {
        ...state,
        stats: null,
        average: null,
      };
    },
    [ACTIONS.CREATE_REVIEW_FAILED]() {
      return {
        ...state,
        newReview: action.payload.errors,
      };
    },
    [ACTIONS.CREATE_REVIEW_SUCCESS]() {
      return {
        ...state,
        newReview: action.payload.review,
      };
    },
    [ACTIONS.RESET_NEW_REVIEW]() {
      return {
        ...state,
        newReview: null,
      };
    },
  };

  if (action.type in actionHandlers) {
    return actionHandlers[action.type]();
  }

  return state;
};

export default reviewsReducer;
